<template>
  <Modal
    @close="close"
    :active="true"
    :showClose="canClose"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Login or Sign up</p>
      </header>
      <section class="modal-card-body">
        <slot />
        <Login :show-title="false">
          <template v-slot:disclaimer>
            <slot name="disclaimer"></slot>
          </template>
        </Login>
      </section>
    </div>
  </Modal>
</template>

<script
  lang="ts"
  setup
>
import Login from "./Login.vue"
import Modal from "../../components/Modal.vue"

const props = defineProps<{
  canClose?: boolean
}>()

const emit = defineEmits(['close'])
function close() {
  if (props.canClose) {
    emit('close')
  }
}

</script>

<style scoped>
.modal-card-body>form:not(:first-child) {
  margin-top: 1rem;
}
</style>
